import * as React from 'react';
import DashboardLayout from '../Layouts/DashboardLayout';
import { FavBg, FavBounds, FavGrid } from '../../components/Favorites/FavUI';
import FavList from './FavList';
import FavDetail from './FavDetail';
import { compose, withState, withHandlers, lifecycle } from 'recompose';

import faves from '../../data/faves';

type FavoritesProps = {
  currFav: number;
  onSelectFave: (id: number) => (event: any) => void;
  onSelectFaveDirect: (id: number) => void;
};

const Favorites: React.SFC<FavoritesProps> = ({ currFav, onSelectFave }) => (
  <DashboardLayout>
    <FavBg>
      <FavBounds>
        <FavGrid>
          <FavList faves={faves} onSelectFave={onSelectFave} />
          <FavDetail currFav={currFav} />
        </FavGrid>
      </FavBounds>
    </FavBg>
  </DashboardLayout>
);

const enhance = compose<FavoritesProps, {}>(
  withState('currFav', 'setCurrFav', ''),
  withHandlers({
    onSelectFaveDirect: ({ setCurrFav }) => (value: number) => setCurrFav(value),
    onSelectFave: ({ setCurrFav }) => (value: number) => (event?: any) => setCurrFav(value),
  }),
  lifecycle<FavoritesProps, {}>({
    async componentDidMount() {
      this.props.onSelectFaveDirect(faves[0]);
    },
  }),
);

export default enhance(Favorites);



// WEBPACK FOOTER //
// ./src/containers/Favorites/Favorites.tsx